import { render, staticRenderFns } from "./AboutPopup.vue?vue&type=template&id=41051c25&"
import script from "./AboutPopup.vue?vue&type=script&lang=js&"
export * from "./AboutPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports